import axios, { CancelTokenSource } from 'axios';
import { Action, Dispatch } from 'redux';

import * as personService from '../../services/person';
import { IMember } from '../group/groupState';
import { PersonActionTypes } from './personActionTypes';

export interface ISetCurrentProfile extends Action<typeof PersonActionTypes.SET_CURRENT_PROFILE> {
    payload: IMember
}

export type PersonActions = ISetCurrentProfile;

export const actionCreators = {
    setCurrentProfile(profile: IMember): ISetCurrentProfile {
        return {
            payload: profile,
            type: PersonActionTypes.SET_CURRENT_PROFILE
        };
    }
};

export const getCurrentUser = (cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => (dispatch: Dispatch<PersonActions>) => {
    return personService.getCurrentUser(cancelTokenSource)
        .then(profile => dispatch(actionCreators.setCurrentProfile(profile)))
        .catch(error => {
            if (!axios.isCancel(error)) {
                throw new Error(`setCurrentProfile: ${error}`);
            }
        });
};